module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDCAMAAABdlVDoAAAAUVBMVEUNXq44er1Bgb/c5/P///8NXq/O3u/+/v+gwOD6/P3X5PJzotHY5fIWZLKGr9cRYbCdvt5CgcHG2exFg8Jrnc5woNDy9vv2+fw6fL49fr+Lstk1c90HAAAABHRSTlPU29z4BZJiuAAAAI5JREFUeF7t1rcOxEAIRVHsZcY5bQz//6FbUNFYlhiQVn6npLkVCNKqi6ipqKS8WWypJER2IPIYTI5FXmxy1ggii/JhcdPjZ2dCfMSUTBwjiCByV2YWXz1eW5OIjW8Q2YHINZv8+3OHCCJZ6VmMuSRif81ZI4i0ASgFQAQRP9QFwO1yjCAyBMBZQcQPRfgBQA+GP2MHnRUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/gr.png
// module id = 3WB2
// module chunks = 0